module.exports = __webpack_public_path__ + "img/home.472898f.png";